import allalerts_active_assailant_selected from '../assets/alerts/alert_active_assailant_selected.png';
import allalerts_active_assailant_selected_hover from '../assets/alerts/alert_active_assailant_selected_hover.png';
import alert_marker from '../assets/alerts/alert_marker.png';
import alert_marker_hover from '../assets/alerts/alert_marker_hover.png';
import alert_marker_selected from '../assets/alerts/alert_marker_selected.png';
import alert_marker_selected_hover from '../assets/alerts/alert_marker_selected_hover.png';
import alert_marker_selected_transparent from '../assets/alerts/alert_marker_selected_transparent.png';
import alert_test_selected from '../assets/alerts/alert_test_selected.png';
import alert_test_selected_hover from '../assets/alerts/alert_test_selected_hover.png';
import alert_train_selected from '../assets/alerts/alert_train_selected.png';
import alert_train_selected_hover from '../assets/alerts/alert_train_selected_hover.png';
import allalerts_active_assailant from '../assets/alerts/allalerts_active_assailant.png';
import allalerts_active_assailant_hover from '../assets/alerts/allalerts_active_assailant_hover.png';
import allalerts_hover_opaque from '../assets/alerts/allalerts_hover_opaque.png';
import allalerts_test from '../assets/alerts/allalerts_test.png';
import allalerts_train from '../assets/alerts/allalerts_train.png';
import allalerts_train_hover from '../assets/alerts/allalerts_train_hover.png';
import allalerts_transparent from '../assets/alerts/allalerts_transparent.png';
import historic_marker from '../assets/alerts/historic_marker.png';
import historic_marker_hover from '../assets/alerts/historic_marker_hover.png';
import {
  getIsUnacceptedActiveAssailant,
  getIsUnacceptedTrainIncident,
} from './utils';

/**
 * Determine the base marker icon
 * @param {Boolean} isAllView - Flag for the all view
 * @param {Boolean} isMostRecent - Flag to determine if a historic location
 */
export const getAlertMarkerIcon = (
  isAllView,
  isMostRecent,
  alert,
  isOpaque,
) => {
  const isUnacceptedActiveAssailant = getIsUnacceptedActiveAssailant(alert);
  const isUnacceptedTrainIncident = getIsUnacceptedTrainIncident(alert);
  const isTestAlert = alert?.emergency_type?.name?.startsWith('TEST');

  if (!isAllView) {
    if (!isMostRecent) {
      return isOpaque ? alert_marker_selected_transparent : historic_marker;
    }
    if (isUnacceptedActiveAssailant) {
      return allalerts_active_assailant_selected;
    }
    if (isUnacceptedTrainIncident) {
      return alert_train_selected;
    }
    if (isTestAlert) {
      return alert_test_selected;
    }
    // make sure its not unaccepted alert then fall back to selected marker
    return isOpaque ? alert_marker_selected_transparent : alert_marker_selected;
  } else {
    if (isOpaque) {
      return allalerts_transparent;
    }
    if (isUnacceptedActiveAssailant) {
      return allalerts_active_assailant;
    }
    if (isUnacceptedTrainIncident) {
      return allalerts_train;
    }
    if (isTestAlert) {
      return allalerts_test;
    }
    return alert_marker;
  }
};
/**
 * Determine the on hover marker icon
 * @param {Boolean} isAllView - Flag for the all view
 * @param {Boolean} isMostRecent - Flag to determine if a historic location
 */
export const getAlertMarkerHoverIcon = (
  isAllView,
  isMostRecent,
  alert,
  isOpaque,
) => {
  const isUnacceptedActiveAssailant = getIsUnacceptedActiveAssailant(alert);
  const isUnacceptedTrainIncident = getIsUnacceptedTrainIncident(alert);
  const isTestAlert = alert?.emergency_type?.name?.startsWith('TEST');

  if (isAllView) {
    if (isUnacceptedActiveAssailant) {
      return allalerts_active_assailant_hover;
    }
    if (isUnacceptedTrainIncident) {
      return allalerts_train_hover;
    }
    if (isTestAlert) {
      return alert_marker_hover;
    }
    if (isOpaque) {
      return allalerts_hover_opaque;
    }
    return alert_marker_hover;
  } else {
    if (!isMostRecent) {
      return historic_marker_hover;
    }
    if (isUnacceptedActiveAssailant) {
      return allalerts_active_assailant_selected_hover;
    }
    if (isUnacceptedTrainIncident) {
      return alert_train_selected_hover;
    }
    if (isTestAlert) {
      return alert_test_selected_hover;
    }
    return alert_marker_selected_hover;
  }
};

export const getAlertMarkerSize = (isAllView, isMostRecent) => {
  if (isAllView) {
    return {
      height: 30,
      width: 20,
    };
  } else {
    return {
      height: !isMostRecent ? 14 : 24,
      width: !isMostRecent ? 14 : 24,
    };
  }
};

export const getAlertCircleColor = isTransparent => {
  return [92, 110, 157, isTransparent ? 0 : 0.35];
};
